import React from 'react';

export default function BudgetRevision() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Budget Revision</h1>
      <p className="text-gray-500">Halaman Budget Revision</p>
    </div>
  );
}
